const festival = {
  name: 'Festivals',
  link: '/festival-travel-packages',
  children: [
    {
      text: 'Afropunk Fest',
      link: '/afropunk-festival-travel-packages',
    },
    {
      text: 'Bonnaroo',
      link: '/bonnaroo-music-festival-travel-packages',
    },
    {
      text: 'Boots and Hearts',
      link: '/boots-and-hearts-music-festival-travel-packages',
    },
    {
      text: 'BottleRock Napa Valley',
      link: '/bottlerock-festival-travel-packages',
    },
    {
      text: 'Coachella',
      link: '/coachella-music-festival-travel-packages',
    },
    {
      text: 'Country Thunder',
      link: '/country-thunder-travel-packages',
    },
    {
      text: 'Electric Daisy Carnival',
      link: '/electric-daisy-carnival-travel-packages',
    },
    {
      text: 'Electric Forest',
      link: '/electric-forest-travel-packages',
    },
    {
      text: 'Essence Festival',
      link: '/essence-music-festival-travel-packages',
    },
    {
      text: 'Faster Horses',
      link: '/faster-horses-festival-travel-packages',
    },
    { text: 'Firefly', link: '/firefly-music-festival-travel-packages' },
    { text: 'FYF Fest', link: '/fyf-fest-travel-packages' },
    {
      text: 'Governors Ball',
      link: '/governor-s-ball-music-festival-travel-packages',
    },
    {
      text: 'Hangout Festival',
      link: '/hangout-music-festival-travel-packages',
    },
    {
      text: 'Life Is Beautiful',
      link: '/life-is-beautiful-festival-travel-packages',
    },
    { text: 'Lollapalooza', link: '/lollapalooza-travel-packages' },
    {
      text: 'Newport Folk Festival',
      link: '/newport-folk-festival-travel-packages',
    },
    {
      text: 'Osheaga',
      link: '/osheaga-music-and-arts-festival-travel-packages',
    },
    { text: 'OVO fest', link: '/ovo-fest-travel-packages' },
    {
      text: 'Panorama',
      link: '/panorama-music-festival-travel-packages',
    },
    {
      text: 'Pitchfork',
      link: '/pitchfork-music-festival-travel-packages',
    },
    { text: 'Sasquatch!', link: '/sasquatch-festival-travel-packages' },
    {
      text: 'Stagecoach',
      link: '/stagecoach-country-music-festival-travel-packages',
    },
    { text: 'Summerfest', link: '/summerfest-travel-packages' },
    {
      text: 'Tortuga Music Festival',
      link: '/tortuga-music-festival-travel-packages',
    },
    {
      text: 'Ultra Music Festival',
      link: '/ultra-music-festival-travel-packages',
    },
    {
      text: 'Welcome to Rockville',
      link: '/welcome-to-rockville-travel-packages',
    },
  ],
}

const performer = {
  name: 'Performers',
  link: '#',
  children: [
    { text: 'Taylor Swift', link: '/taylor-swift-travel-packages' },
    { text: 'Morgan Wallen', link: '/morgan-wallen-travel-packages' },
    { text: 'Luke Combs', link: '/luke-combs-travel-packages' },
    { text: 'Zach Bryan', link: '/zach-bryan-travel-packages' },
    { text: 'Beyoncé', link: '/beyonce-travel-packages' },
    { text: 'Drake', link: '/drake-travel-packages' },
    {
      text: 'Billie Eilish',
      link: '/billie-eilish-travel-packages',
    },
    { text: 'Bad Bunny', link: '/bad-bunny-travel-packages' },
    { text: 'Lady Gaga', link: '/lady-gaga-travel-packages' },
    { text: 'Coldplay', link: '/coldplay-travel-packages' },
    { text: 'Metallica', link: '/metallica-travel-packages' },
    { text: 'Post Malone', link: '/post-malone-travel-packages' },
    { text: 'Shakira', link: '/shakira-travel-packages' },
    { text: 'Kendrick Lamar', link: '/kendrick-lamar-travel-packages' },
    { text: 'Chris Stapleton', link: '/chris-stapleton-travel-packages' },
    { text: 'SZA', link: '/sza-travel-packages' },
    { text: 'Bruno Mars', link: '/bruno-mars-travel-packages' },
    { text: 'The Weeknd', link: '/the-weeknd-travel-packages' },
    { text: 'Luke Bryan', link: '/luke-bryan-travel-packages' },
    { text: 'Ed Sheeran', link: '/ed-sheeran-travel-packages' },
    { text: 'AC/DC', link: '/ed-sheeran-travel-packages' },
    { text: 'Noah Kahan', link: '/noah-kahan-travel-packages' },
    { text: 'Zach Brown Band', link: '/zac-brown-band-travel-packages' },
    { text: 'Lainey Wilson', link: '/lainey-wilson-travel-packages' },
    { text: 'Eric Church', link: '/eric-church-travel-packages' },
    { text: 'Kane Brown', link: '/kane-brown-travel-packages' },
    { text: 'Travis Scott', link: '/travis-scott-travel-packages' },
    { text: 'Foo Fighters', link: '/foo-fighters-travel-packages' },
    { text: 'Olivia Rodrigo', link: '/olivia-rodrigo-travel-packages' },
    { text: 'Doja Cat', link: '/doja-cat-travel-packages' },
    { text: 'Justin Timberlake', link: '/justin-timberlake-travel-packages' },
    { text: 'Usher', link: '/usher-travel-packages' },
    { text: 'Paul McCartney', link: '/paul-mccartney-travel-packages' },
    { text: 'Green Day', link: '/green-day-travel-packages' },
    {
      text: 'The Rolling Stones',
      link: '/the-rolling-stones-travel-packages',
    },
    { text: 'Carrie Underwood', link: '/carrie-underwood-travel-packages' },
    { text: 'George Strait', link: '/george-strait-travel-packages' },
    { text: 'Paramore', link: '/paramore-travel-packages' },
    { text: 'Jelly Roll', link: '/jelly-roll-travel-packages' },
    { text: 'Parker McCollum', link: '/parker-mccollum-travel-packages' },
  ],
}

const theatre = {
  name: 'Theater',
  link: '#',
  children: [
    {
      text: 'Aladdin',
      link: '/aladdin-travel-packages',
    },
    {
      text: 'An American In Paris',
      link: '/an-american-in-paris-travel-packages',
    },
    {
      text: 'Come From Away',
      link: '/come-from-away-travel-packages',
    },
    {
      text: 'Dear Evan Hansen',
      link: '/dear-evan-hansen-travel-packages',
    },
    {
      text: 'Elf The Musical',
      link: '/elf-the-musical-travel-packages',
    },
    {
      text: 'Gabriel Iglesias',
      link: '/gabriel-iglesias-travel-packages',
    },
    {
      text: 'Hamilton',
      link: '/hamilton-travel-packages',
    },
    {
      text: 'Hello Dolly',
      link: '/hello-dolly-travel-packages',
    },
    {
      text: 'Jeff Dunham',
      link: '/jeff-dunham-travel-packages',
    },
    {
      text: 'Jerry Seinfeld',
      link: '/jerry-seinfeld-travel-packages',
    },
    {
      text: 'Jersey Boys',
      link: '/jersey-boys-travel-packages',
    },
    {
      text: 'Kevin Hart',
      link: '/kevin-hart-travel-packages',
    },
    {
      text: 'Kinky Boots',
      link: '/kinky-boots-travel-packages',
    },
    {
      text: 'Mamma Mia',
      link: '/mamma-mia-travel-packages',
    },
    {
      text: 'Phantom of the Opera',
      link: '/phantom-of-the-opera-travel-packages',
    },
    {
      text: 'Something Rotten',
      link: '/something-rotten-travel-packages',
    },
    {
      text: 'The Book Of Mormon',
      link: '/the-book-of-mormon-travel-packages',
    },
    {
      text: 'The Lion King',
      link: '/the-lion-king-travel-packages',
    },
    {
      text: 'Trevor Noah',
      link: '/trevor-noah-travel-packages',
    },
    {
      text: 'Wicked',
      link: '/wicked-travel-packages',
    },
  ],
}

export const musicNavigationData = [
  {
    name: 'Genres',
    items: [festival, performer, theatre],
  },
]
